<template>
    <div class="button-container">
        <div class="flex flex-col md:flex-row justify-center gap-3 button-wrapper">
            <el-button type="primary" plain @click="handleNext" :disable="literatureList.length >= 10" class="mobile-button">选择文献</el-button>
            <!-- <el-button type="primary" plain @click="pasteLiterature" :disable="literatureList.length >= 10" class="mobile-button">手动添加</el-button> -->
        </div>
    </div>
    
  <el-form-item name="literatureList" label-width="0">
    <div class="flex flex-col w-[100%] px-4">
        <div 
            class="flex justify-between w-full items-center bg-blue-100 p-3 rounded-md mb-2"
            v-for="(item, index) in literatureList" 
            :key="getUniqueKey(item)"
        >
            <div class="truncate flex-1 mr-3 text-sm" :title="item.quote">[{{ index + 1 }}]{{ item.quote.replace(/^\[\d+\]/, '') }}</div>
            <el-icon @click="handleDelete(item, index)" class="cursor-pointer text-red-500"><Delete /></el-icon>
        </div>
    </div>
  </el-form-item>

 <el-dialog
    v-model="dialogVisible"
    title="选择文献"
    :width="isMobile ? '90%' : '600px'"
    class="mobile-dialog"
  >
    <SelectLiterature v-model="literatureList" :isBack="isBack" :form-data="form" />
    <template #footer>
      <div class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false" class="mobile-dialog-button">
          选好了
        </el-button>
      </div>
    </template>
  </el-dialog>

   <el-dialog
    v-model="pasteVisible"
    title="粘贴文献"
    :width="isMobile ? '90%' : '600px'"
    class="mobile-dialog"
  >
    <PasteLiterature v-model="literatureList" />
    <template #footer>
      <div class="dialog-footer">
        <el-button type="primary" @click="pasteVisible = false" class="mobile-dialog-button">
          选好了
        </el-button>
      </div>
    </template>
  </el-dialog>

</template>
  
<script setup lang="ts">
import { toRefs, ref, watch, computed } from 'vue';
import { defineProps, defineExpose } from 'vue';
import SelectLiterature from '@/components/selectLiterature.vue'
import PasteLiterature from '@/components/pasteLiterature.vue'
import { Delete } from '@element-plus/icons-vue';
import { Literature } from '@/components/Table/interfaces';

interface Props {
form: any;
}
const props = defineProps<Props>();
const { form } = toRefs(props);
const literatureList = ref<Literature[]>([]);
const isBack = ref(false);

// 检测是否为移动设备
const isMobile = computed(() => {
  return window.innerWidth <= 768;
});

console.log(form.value, 'topicValue')

watch(
  () => form.value.literature,
  (newVal) => {
    if (newVal && JSON.stringify(newVal) !== JSON.stringify(literatureList.value)) {
      literatureList.value = [...newVal];
    }
  },
  { deep: true, immediate: true }
);

watch(
  literatureList,
  (newVal) => {
    // 处理 quote 字段，去除原有[n]并加自增编号
    const processed = newVal.map((item, idx) => ({
      ...item,
      quote: `[${idx + 1}]${item.quote.replace(/^\[\d+\]/, '')}`
    }));
    if (JSON.stringify(processed) !== JSON.stringify(form.value.literature)) {
      form.value.literature = processed;
    }
  },
  { deep: true }
);

const dialogVisible = ref(false)
const pasteVisible = ref(false)

// const pasteLiterature = () => {
//   pasteVisible.value = true
// }

const getUniqueKey = (item: Literature) => `${item.name}-${item.source}`;

const handleDelete = (item: Literature, index: number) => {
  literatureList.value.splice(index, 1)
}

// 监听上一步按钮的点击事件
const handleBack = () => {
  isBack.value = true;
  dialogVisible.value = true;
}

// 监听下一步按钮的点击事件
const handleNext = () => {
  isBack.value = false;
  dialogVisible.value = true;
}

const handleStepChange = (isNext: boolean) => {
    if(isNext) {
        literatureList.value = [];
    }
}

// 暴露方法给父组件
defineExpose({
  handleBack,
  handleStepChange
});
</script>

<style scoped>
/* 按钮容器样式 */
.button-container {
  margin-bottom: 30px;
  padding: 0 16px;
}

.mobile-button {
  min-width: 100px;
  height: 36px;
  font-size: 13px;
  font-weight: 500;
}

/* 平板端按钮样式 */
@media (max-width: 1024px) and (min-width: 769px) {
  .button-container {
    margin-bottom: 20px;
    padding: 0 10px;
  }
  
  .mobile-button {
    min-width: 90px;
    height: 34px;
    font-size: 12px;
  }
}

/* 移动端按钮样式 */
@media (max-width: 768px) {
  .button-container {
    margin-bottom: 16px;
    padding: 0 16px;
    display: flex;
    justify-content: center;
  }
  
  .button-wrapper {
    display: flex !important;
    flex-direction: row !important;
    justify-content: center !important;
    align-items: center;
    flex-wrap: nowrap;
    gap: 12px !important;
  }
  
  .mobile-button {
    max-width: 100px;
    min-width: 80px;
    width: auto;
    height: 40px;
    font-size: 14px;
    padding: 0 16px;
    flex-shrink: 0;
  }
}

/* 小屏幕手机样式 */
@media (max-width: 480px) {
  .button-container {
    margin-bottom: 14px;
    padding: 0 12px;
  }
  
  .button-wrapper {
    gap: 8px !important;
  }
  
  .mobile-button {
    max-width: 85px;
    min-width: 70px;
    height: 38px;
    font-size: 13px;
    padding: 0 12px;
  }
}

/* 对话框按钮样式 */
.mobile-dialog-button {
  min-width: 80px;
  height: 32px;
  font-size: 13px;
}

/* 移动端对话框按钮样式 */
@media (max-width: 768px) {
  .mobile-dialog-button {
    width: 100%;
    height: 36px;
    font-size: 14px;
  }
}
</style>
  